export default {
  selectCity (state, city) {
    state.soukecityId = city.cid
    state.cityName = city.cname
  },
  changeTopNav (state, topnav) {
    state.topNav = topnav
  },
  setCurrCity (state, currCity) {
    state.currCityId = currCity.cid
    state.currCityName = currCity.city
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js